import { apiGet, apiPost, apiPut } from "./http";

export type MemberMembershipYearRow = {
  year: number;
  validFrom: string;
  validTo: string;
  isCurrent: boolean;
  isEnabled: boolean;
  levelCount: number;
  createdAtUtc: string;
};

export type MemberMembershipYearLevelRow = {
  id: string;
  memberLevelDefinitionId: string;
  levelKey: string;
  levelName: string;
  annualFeeYuan: number;
  enrollmentBonusPoints: number;
  sortOrder: number;
  isEnabled: boolean;
};

export function fetchMemberMembershipYears(tenantLegacyId: string) {
  return apiGet<MemberMembershipYearRow[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-membership-years`,
  );
}

export function createMemberMembershipYear(
  tenantLegacyId: string,
  body: { year: number; validFrom?: string; validTo?: string; isEnabled?: boolean },
) {
  return apiPost<MemberMembershipYearRow>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-membership-years`,
    body,
  );
}

export function updateMemberMembershipYear(
  tenantLegacyId: string,
  year: number,
  body: { validFrom?: string; validTo?: string; isEnabled?: boolean },
) {
  return apiPut<MemberMembershipYearRow>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-membership-years/${year}`,
    body,
  );
}

export function setCurrentMemberMembershipYear(tenantLegacyId: string, year: number) {
  return apiPost<MemberMembershipYearRow>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-membership-years/${year}/set-current`,
    {},
  );
}

export function migrateMemberMembershipYearsFromLegacy(tenantLegacyId: string) {
  return apiPost<{ migratedYearCount: number }>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-membership-years/migrate-from-legacy`,
    {},
  );
}

export function fetchMemberMembershipYearLevels(tenantLegacyId: string, year: number) {
  return apiGet<MemberMembershipYearLevelRow[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-membership-years/${year}/levels`,
  );
}

export function putMemberMembershipYearLevels(
  tenantLegacyId: string,
  year: number,
  levels: Array<{
    levelKey: string;
    levelName?: string;
    annualFeeYuan?: number;
    enrollmentBonusPoints?: number;
    sortOrder?: number;
    isEnabled?: boolean;
  }>,
) {
  return apiPut<MemberMembershipYearLevelRow[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/member-membership-years/${year}/levels`,
    { levels },
  );
}
